import React, { Component } from 'react';
import { registryCombineReducer } from 'mt-react-common/modules/authUserOutputCash/combines/authUserOutputAccountFrom/combineRegistry';
import PropTypes from 'prop-types';
import UserOutputCashAccountForm from './UserOutputCashAccountForm';

class UserOutputCashAccountFormRWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: `userOutputCashAccountType${this.props.outputAccountsItem.id}Form`
    };
  }

  componentWillMount() {
    registryCombineReducer(this.state.reducerName);
  }

  render() {
    return (
      <React.Fragment>
        <UserOutputCashAccountForm
          {...this.props}
          reducerName={this.state.reducerName}
        />
      </React.Fragment>
    );
  }
}

UserOutputCashAccountFormRWrapper.propTypes = {
  reducerNameOutputCashAccounts: PropTypes.string.isRequired,
  reducerNameOutputCashFrom: PropTypes.string.isRequired,
  outputAccountsItem: PropTypes.shape({
    id: PropTypes.number.isRequired,
    meAccountNumber: PropTypes.string,
    placeholder: PropTypes.string.isRequired
  }).isRequired
};

export default UserOutputCashAccountFormRWrapper;



// WEBPACK FOOTER //
// ./src/components/UserOutputCash/UserOutputCashForm/UserOutputCashAccountForm/index.js